// @flow
import React, { Component } from 'react';

import styles from '../styles/PageHeader.scss';

type Props = {
  title: string,
}

class PageHeader extends Component<Props> {
  render() {
    return (
      <div className={styles.pageHeader}>
        {this.props.title}
      </div>
    );
  }
}

export default PageHeader;



// WEBPACK FOOTER //
// ./client/src/components/PageHeader.jsx